import { render } from "./MaoBottomMenu.vue?vue&type=template&id=08b1a1b2&scoped=true"
import script from "./MaoBottomMenu.vue?vue&type=script&lang=js"
export * from "./MaoBottomMenu.vue?vue&type=script&lang=js"

import "./MaoBottomMenu.vue?vue&type=style&index=0&id=08b1a1b2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b1a1b2"]])

export default __exports__